export default {
  AudioButton: {
    play: '播放試題',
  },
  ezinterview_video_help: {
    section1: [
      '1、瀏覽器檢測失敗。',
      '視頻面試需要使用chrome 60版本及以上的瀏覽器,請根據相關版本下載瀏覽器:',
      'window版本下載',
      'mac版本下載',
      'linux版本下載',
      'ios版本下載',
      'android版本下載',
      '現時不支持其他瀏覽器。',
    ],
    section2: [
      '2、監視器檢測失敗。',
      '（1）、請確保設備帶有監視器或外接監視器設備,並安裝了驅動程序。',
      '（2）、請關閉電腦殺毒軟體、代理VPN等,確保網速在100kb/s以上。',
      '（3）、允許瀏覽器啟用監視器許可權（請點擊允許）。',
      '（4）、檢查流覽器地址欄右側是否對監視器和麥克風設定禁用。',
      '（5）、安全設置中,請將網站監視器,麥克風,聲音許可權設定為允許。',
    ],
    section3: [
      '3、麥克風檢測失敗。',
      '（1）、請確保設備帶有麥克風或外接麥克風設備並安裝了驅動程序,設備未調至靜音模式。',
      '（2）、請關閉電腦殺毒軟體、代理VPN等,確保網速在100kb/s以上。',
      '（3）、允許瀏覽器啟用了麥克風許可權（請點擊允許）。',
      '（4）、檢查流覽器地址欄右側是否對監視器和麥克風設定禁用。',
      '（5）、安全設置中,請將網站監視器,麥克風,聲音許可權設定為允許。',
    ],
    section4: [
      '4、聲音檢測失敗。',
      '（1）、請確保電腦帶有揚聲器或耳機,並安裝相關驅動,設備未調至靜音模式。',
      '（2）、請關閉電腦殺毒軟體、代理VPN等,確保網速在100kb/s以上。',
      '（3）、允許瀏覽器啟用了監視器、麥克風許可權（請點擊允許）。',
      '（4）、檢查流覽器地址欄右側是否對監視器和麥克風設定禁用。',
      '（5）、安全設置中,請將網站監視器,麥克風,聲音許可權設定為允許。',
    ],
    tips: '去請去應用商店蒐索最新版chrome瀏覽器下載',
  },
  grading_level: {
    title: '評分標準',
  },
  history_score: {
    absent: '候選人缺考,無成績',
    fraud: '候選人舞弊,無成績',
  },
  interviewer_navbar: {
    time: '北京时間',
  },
  loginout_btn: {
    logout: '登出',
    signOutCofirm: '確定退出面試評分系統？',
    signOutCancel: '取消退出',
  },
  navbar: {
    placeholder: '名稱',
  },
  operate_and_time: {
    time: '北京时間',
  },
  operate_mobile: {
    title: '設備檢測',
  },
  pre_detection: {
    title: '設備檢測',
    browser: '瀏覽器',
    help: '幫助？',
    video: '監視器',
    audio: '麥克風',
    broadWidth: '視頻頻寬',
    delay: '延遲',
    confirm: '確定',
    helpTitle: '易面使用幫助',
    close: '關閉',
    btnName1: ['點擊檢測麥克風', '停止錄音…'],
    btnName2: ['播放聲音', '停止播放'],
    audioDevice: '麥克風設備',
    videoDevice: '監視器設備',
    audioMsg: '請先停止播放',
    audioConfirmMsg: '檢測麥克風期間,系統將錄製一段您的聲音,您可以在錄製好後點擊播放聲音按鈕來確定麥克風是否有效',
    recordMsg1: '請先點擊檢測麥克風',
    recordMsg2: '請先停止錄音',
    errorTips: '請嘗試通過瀏覽器打開此頁面以訪問監視器設備',
  },
  table: {
    name: '姓名',
    number: '編號',
    gender: '性別',
    status: '狀態',
    score: '我的評分',
    average: '平均成績',
    class: '等級',
    checkIn: '已簽到',
    signIn: '簽到',
    preview: '圖片預覽',
    noMsg: '暫無候選人',
    actions: '操作',
    aboveAverage: '高於平均分',
    belowAverage: '低於平均分',
    statusText: {
      unsubmitted: '進行中',
      waiting: '未開始',
      interviewing: '進行中',
      complete: '已結束',
      processing: '已結束',
      confirmed: '已結束',
      unconfirmed: '已結束',
    },
    button: {
      unsubmitted: '修改成績',
      waiting: '評分',
      interviewing: '評分',
      complete: '修改成績',
      processing: '查看',
      confirmed: '修改成績',
      unconfirmed: '修改成績',
      view: '查看',
    },
    genderOption: {
      男: '男',
      女: '女',
    },
    scoreTag: {
      unconfirmed: '未通過',
      confirmed: '已通過',
      processing: '審核中',
    },
  },
  video_interview: {
    tipMsg: '連接中,請稍後…',
    failMsg: '連接失敗,請檢查攝像和音訊設備',
    retry: '點擊重試',
    timeMsg: '分鐘後將結束視頻',
    videoMsg: '您的視頻面試視窗在另外一臺設備或標籤頁被打開',
    detectionMsg: '請嘗試通過瀏覽器打開此頁面以訪問監視器設備',
  },
  video_table: {
    scoreStatus: '評分狀態',
    arrangement: '安排名稱',
    time: '面試時間',
    name: '姓名',
    gender: '性別',
    score: '得分',
    average: '平均成績',
    class: '等級',
    login: '已登入',
    online: '線上',
    offline: '離線',
    view: '查看',
    noMsg: '暫無候選人',
    status: {
      waiting: '未開始',
      interviewing: '進行中',
      complete: '已結束',
      default: '出錯了',
    },
    genderOption: {
      男: '男',
      女: '女',
    },
  },
  IframePopup: {
    title: '考生試卷',
  },
  fontSize: {
    label: '字型大小',
    size: {
      normal: '正常',
      large: '大',
      xlarge: '最大',
    },
  },
  FileViewer: {
    unknownFile: '未知檔案',
    downloadFile: '下載檔案',
    fileType: {
      doc: 'Word 文件',
      xls: 'Excel 表格',
      ppt: 'PowerPoint 簡報',
      zip: '壓縮檔案',
      audio: '音訊檔案',
      video: '視訊檔案',
      fallback: '{ext} 檔案',
    },
  },
};
